import { MprcSpinnerIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    id: string;
}

export const AuditLogDetail: React.FC<IProps> = ({ id }) => {

    ////////////////////////////////////////////////////////////////////////////////
    const api = useCoreApi();

    const [loading, setLoading] = useState<boolean>(true);
    const [detailContent, setDetailContent] = useState<string | null>(null);

    ////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {

        async function loadDetail() {
            setLoading(true);

            try {
                var result = await api.v1.auditLog.getAuditLogDetail({ id });
                setDetailContent(result.data);
            }
            catch (e) {
                MprcRequestSnackbarErrorReport(e);
            }
            finally {
                setLoading(false);
            }
        }

        loadDetail();

    }, []);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return loading
        ? <MprcSpinnerIndicator />
        : (
            <pre>
                {detailContent}
            </pre>
        );
};
